import React from 'react';
import AuthBox from './components/Auth/AuthBox';

function App() {
  return (
    <div className="App">
      <AuthBox />
    </div>
  );
}

export default App;